(function () {
  const SCROLL_GUARD = 700;
  const DESKTOP = 1024;

  class ProductFeatures {
    constructor(root) {
      this.root          = root;
      this.triggers      = [...root.querySelectorAll('[data-tab-trigger]')];
      this.cards         = [...root.querySelectorAll('[data-tab-card]')];
      this.track         = root.querySelector('[data-tab-carousel-track]');
      this.prevBtns      = [...root.querySelectorAll('[data-tab-prev]')];
      this.nextBtns      = [...root.querySelectorAll('[data-tab-next]')];
      this.active        = 0;
      this.busy          = false;
      this.scrollTimer   = null;
      this.initialOffset = 0;

      if (!this.cards.length) return;
      this.calculateInitialOffset();
      this.bindEvents();
      this.observeCarousel();
      this.updatePrevNext();
    }

    calculateInitialOffset() {
      if (this.cards[0]) this.initialOffset = this.cards[0].offsetLeft;
    }

    bindEvents() {
      this.triggers.forEach((t) => {
        t.addEventListener('click', () => {
          const idx = parseInt(t.dataset.tabIndex, 10);
          if (idx !== this.active) this.activate(idx);
        });
      });

      const list = this.root.querySelector('[data-tab-list]');
      if (list) {
        list.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.focusTab(this.active + 1); }
          if (e.key === 'ArrowLeft')  { e.preventDefault(); this.focusTab(this.active - 1); }
          if (e.key === 'Home')       { e.preventDefault(); this.focusTab(0); }
          if (e.key === 'End')        { e.preventDefault(); this.focusTab(this.triggers.length - 1); }
        });
      }

      this.prevBtns.forEach((btn) => btn.addEventListener('click', () => {
        if (this.active > 0) this.activate(this.active - 1);
      }));
      this.nextBtns.forEach((btn) => btn.addEventListener('click', () => {
        if (btn.getAttribute('aria-disabled') !== 'true') this.activate(this.active + 1);
      }));

      if (this.track) {
        this.track.addEventListener('scrollend', () => {
          clearTimeout(this.scrollTimer);
          this.busy = false;
        }, { passive: true });
      }
    }

    observeCarousel() {
      if (!this.track || !this.cards.length || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((entries) => {
        if (this.busy) return;
        if (window.innerWidth >= DESKTOP) return;
        const top = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!top) return;
        const idx = parseInt(top.target.dataset.tabIndex, 10);
        if (Number.isFinite(idx) && idx !== this.active) this.setActive(idx);
      }, { root: this.track, threshold: 0.6 });
      this.cards.forEach((card) => io.observe(card));
    }

    focusTab(idx) {
      if (!this.triggers.length) return;
      const clamped = Math.max(0, Math.min(this.triggers.length - 1, idx));
      this.triggers[clamped].focus();
      this.activate(clamped);
    }

    setActive(idx) {
      this.triggers.forEach((t, i) => {
        const isActive = i === idx;
        t.setAttribute('aria-selected', String(isActive));
        t.setAttribute('data-state', isActive ? 'active' : 'inactive');
      });
      this.active = idx;
      this.updatePrevNext();
    }

    updatePrevNext() {
      const atStart = this.active === 0;
      let atEnd = this.active >= this.cards.length - 1;
      if (!atEnd && this.track) {
        const lastCard = this.cards[this.cards.length - 1];
        atEnd = this.cards[this.active].offsetLeft + this.track.clientWidth >= lastCard.offsetLeft + lastCard.offsetWidth;
      }
      this.prevBtns.forEach((btn) => btn.setAttribute('aria-disabled', String(atStart)));
      this.nextBtns.forEach((btn) => btn.setAttribute('aria-disabled', String(atEnd)));
    }

    activate(idx) {
      if (idx === this.active) return;
      this.setActive(idx);
      const card = this.cards[idx];
      if (!card || !this.track) return;
      this.busy = true;
      this.track.scrollTo({ left: card.offsetLeft - this.initialOffset, behavior: 'smooth' });
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => { this.busy = false; }, SCROLL_GUARD);
    }
  }

  function init(root) {
    root.querySelectorAll('[data-product-features]').forEach((el) => new ProductFeatures(el));
  }
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
